var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", { attrs: { title: "面接情報" } }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "boss-joboffer-title boss-setting margin-top-2",
            attrs: { "data-test": "interview-setting-title" },
          },
          [_vm._v("\n      公開設定\n    ")]
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("interview-information-jobs", {
          attrs: { jobs: _vm.jobs, interviews: _vm.interviewInformations },
          on: { update: _vm.updateJobInterviewTies },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "boss-joboffer-title boss-setting margin-top-2",
            attrs: { "data-test": "interview-information-title" },
          },
          [_vm._v("\n      面接情報\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x align-justify" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "medium-2 cell" }, [
            _c(
              "button",
              {
                staticClass: "float-right boss-button boss-button-new",
                attrs: { "data-test": "register-button-information" },
                on: {
                  click: function ($event) {
                    return _vm.$router.push({
                      name: "interviewInformationRegister",
                    })
                  },
                },
              },
              [
                _c("span", { staticClass: "boss-icon-new" }),
                _vm._v(" "),
                _c("span", { staticClass: "boss-button-new-text" }, [
                  _vm._v("新規登録する"),
                ]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.interviewInformations.length > 0
          ? _c(
              "div",
              [
                _c("interview-informations", {
                  attrs: { interviews: _vm.interviewInformations },
                  on: { fetch: _vm.fetch },
                }),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "grid-x grid-margin-y align-center margin-top-2" },
              [
                _c(
                  "span",
                  {
                    staticClass: "cell medium-4 subheader",
                    attrs: { "data-test": "no-infornmation-text" },
                  },
                  [_vm._v("面接情報が登録されていません。")]
                ),
              ]
            ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "boss-joboffer-title boss-setting margin-top-2",
            attrs: { "data-test": "interview-place-title" },
          },
          [_vm._v("\n      面接場所\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x align-justify" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "medium-2 cell" }, [
            _c(
              "button",
              {
                staticClass: "float-right boss-button boss-button-new",
                attrs: { "data-test": "register-button-place" },
                on: {
                  click: function ($event) {
                    return _vm.callMordalInner()
                  },
                },
              },
              [
                _c("span", { staticClass: "boss-icon-new" }),
                _vm._v(" "),
                _c("span", { staticClass: "boss-button-new-text" }, [
                  _vm._v("新規登録する"),
                ]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.places.length > 0
          ? _c(
              "div",
              [
                _c("interview-places", {
                  attrs: { places: _vm.places },
                  on: {
                    fetchPlaces: _vm.fetchPlaces,
                    editInterviewPlace: _vm.editInterviewPlace,
                  },
                }),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "grid-x grid-margin-y align-center margin-top-2" },
              [
                _c(
                  "span",
                  {
                    staticClass: "cell medium-4 subheader",
                    attrs: { "data-test": "no-place-text" },
                  },
                  [_vm._v("面接場所が登録されていません。")]
                ),
              ]
            ),
        _vm._v(" "),
        _c("entry-interview-place-modal-inner", {
          ref: "mordalInner",
          attrs: { "interview-place": _vm.interviewPlace },
          on: {
            fetchPlaces: _vm.fetchPlaces,
            resetInterviewPlace: _vm.resetInterviewPlace,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "align-justify" }, [
      _c("p", { staticClass: "margin-0" }, [
        _vm._v(
          "\n        応募者に公開する「面接情報」を求人ごとに設定します。\n      "
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "boss-text margin-top-0" }, [
        _vm._v(
          "\n        「面接情報」は企業様管理画面でのみ登録・編集が可能です。営業担当者・制作担当者側では編集できません。\n      "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "boss-text margin-top-0 margin-bottom-1",
        attrs: { "data-test": "interview-setting-description" },
      },
      [
        _vm._v("\n      公開する面接情報を、求人ごとに設定できます。"),
        _c("br"),
        _vm._v(
          "\n      掲載中、あるいは今後掲載予定の求人が、以下に表示されます。通常、掲載開始日の前日15時以降から設定可能です。\n    "
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "medium-10 cell" }, [
      _c(
        "p",
        {
          staticClass: "boss-text margin-top-0 margin-bottom-1",
          attrs: { "data-test": "interview-information-description" },
        },
        [
          _vm._v(
            "\n          登録すると「公開設定」で選択肢に表示されます。以下の新規登録・編集・削除は、掲載状態に関わらず、いつでも可能です。\n        "
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "medium-10 cell" }, [
      _c(
        "p",
        {
          staticClass: "boss-text margin-top-0 margin-bottom-1",
          attrs: { "data-test": "interview-place-description" },
        },
        [
          _vm._v(
            "\n          登録すると「応募者管理」画面で、応募者へのメッセージやリマインドメールにご利用いただけます。\n        "
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }